import { toast, type Id, type ToastContent } from 'react-toastify';

export const tLoading = (message: ToastContent): Id => toast.loading(message, { closeOnClick: true });

const commonOptions = {
  isLoading: false,
  closeOnClick: true,
  draggable: true,
};

export const tSuccess = (id: Id, message: ToastContent, { autoClose } = { autoClose: 2500 }): void => {
  toast.update(id, {
    render: message,
    type: 'success',
    autoClose,
    ...commonOptions,
  });
};

export const tError = (id: Id, message: ToastContent, { autoClose } = { autoClose: 5000 }): void => {
  toast.update(id, {
    render: message,
    type: 'error',
    autoClose,
    ...commonOptions,
  });
};

export const tWarning = (id: Id, message: ToastContent, { autoClose } = { autoClose: 4000 }): void => {
  toast.update(id, {
    render: message,
    type: 'warning',
    autoClose,
    ...commonOptions,
  });
};
